import { render } from "./Footer.vue?vue&type=template&id=9da34d9a&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=9da34d9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da34d9a"]])

export default __exports__